import { render } from "./home-view.vue?vue&type=template&id=56d2d99c"
import script from "./home-view.vue?vue&type=script&lang=js"
export * from "./home-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__